export default __webpack_public_path__ + "static/media/Newsletter 001.b7e8a892.png";